export default __webpack_public_path__ + "./font/708ca66bdeda5b36160903c3f78f56ba.ttf";